<div class="form-group materialize {{behaviourClasses}}">
	<kendo-numerictextbox #inputControl class="form-control" [id]="controlId" [spinners]="false" [format]="format" [min]="min" [max]="max"
		[decimals]="decimals" [autoCorrect]="autoCorrect" [disabled]="disabled" [readonly]="readonly" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)"
		[(ngModel)]="value" (valueChange)="_handleChange($event)" (keyup.enter)="_handleEnterEvent()">
	</kendo-numerictextbox>
	<label [for]="controlId" (click)="inputControl.focus()">{{label}}</label>
	<validation-messages *ngIf="showFailures" [messages]="failures"></validation-messages>
	<span *ngIf="infoMessage" class="feedback">{{infoMessage}}</span>
</div>